import { Injectable, EventEmitter } from "@angular/core"

@Injectable({
    providedIn: "root",
})
export class MediaTypeNavService {
    categoryTitleInViewport = new EventEmitter<any>()
    constructor() {}
}
